import type { ReactNode } from 'react'
import { Navigate } from 'react-router'

import { useAuth } from '@/shared/contexts/AuthContext'

export function RequireAdmin({ children }: { children: ReactNode }): React.ReactElement {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-muted-foreground">جارٍ التحميل...</div>
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />
  if (user.type !== 'admin') return <Navigate to="/competition" replace />

  return <>{children}</>
}
